import { motion } from "framer-motion";
import GlassSurface from "../common/GlassSurface";
import { useCursor } from "../cursor/useCursor";
import { CURSORS } from "../cursor/cursors";
import downloadArrow from "../../../assets/svgs/download_arrow.svg"

export default function AboutCard() {
  const { cursor } = useCursor()
  return (
    <motion.div
      {...cursor({ ...CURSORS.default, background: "#fff", blendMode: "difference", size: 50 })}
      whileHover={{
        y: -8,
        scale: 1.02,
      }}
      transition={{
        type: "spring",
        stiffness: 250,
      }}
      className="
        absolute
        z-30

        bottom-5
        left-1/2
        -translate-x-1/2

        w-[calc(100%-32px)]
        h-[110px]

        sm:w-[calc(100%-48px)]
        sm:h-[125px]

        md:w-[500px]
        md:h-[150px]

        lg:bottom-12
        lg:left-10
        lg:translate-x-0
        lg:w-[550px]
        lg:h-[165px]

        xl:bottom-20
        xl:w-[600px]
        xl:h-[180px]
      "
    >
      <GlassSurface
        width="100%"
        height="100%"
        borderRadius={55}
        borderWidth={0.05}
        opacity={0.9}
        backgroundOpacity={0.24}
        displace={3.7}
        blur={9}
        distortionScale={30}
        className="shadow-[0_30px_80px_rgba(0,0,0,.4)]"
      >
        <div className="flex h-full w-full items-center">

          {/* =================================
              DOWNLOAD CV
          ================================= */}
          <a href="/resume.pdf"
            download='Badusha_Pareed_CV.pdf'
            target="_blank"
            rel="noopener noreferrer">

            <div
            {...cursor({
                        ...CURSORS.icon,
                        iconPath:downloadArrow,
                        text:"",
                        size: 90,
                        blendMode:"difference",
                        color:"#fff"
                    })}
              className="flex h-full w-[90px] shrink-0 items-center justify-center sm:w-[110px] md:w-[135px] lg:w-[160px] xl:w-[180px]"
            >
              <motion.img
                src="/download_cv.svg"
                alt="Download CV"
                animate={{
                  rotate: 360,
                }}
                transition={{
                  duration: 18,
                  repeat: Infinity,
                  ease: "linear",
                }}
                className=" h-[70px] w-[70px] sm:h-[80px] sm:w-[80px] md:h-[95px] md:w-[95px] lg:h-[115px] lg:w-[115px] xl:h-[130px] xl:w-[130px]"
              />
            </div>
          </a>


          {/* =================================
              ABOUT
          ================================= */}

          <div
            className="
              flex
              min-w-0
              flex-1
              items-center
              justify-center
              overflow-hidden
            "
          >
            <motion.h2
              className="
                whitespace-nowrap
                font-pix32
                leading-none
                text-white

                text-[48px]

                sm:text-[55px]

                md:text-[70px]

                lg:text-[90px]

                xl:text-[120px]
              "
            >
              ABOUT
            </motion.h2>
          </div>

        </div>
      </GlassSurface>
    </motion.div>
  );
}